import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GenerateLink from './GenerateLink';
import { getoffRoleEmployeesData, getDataForDropdown, updateStatusOffroleEmployee, generateLinkForOnboarding } from 'services/redux/OffRoleEmployees/action';

const mapStateToProps = (state) => ({
    getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
    getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas,
    statusUpdationByBusinessHead: state.offroleEmployeesReducer.statusUpdationByBusinessHead,
    onboardingLinkForEmployee: state.offroleEmployeesReducer.onboardingLinkForEmployee
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getoffRoleEmployeesData,
        getDataForDropdown,
        updateStatusOffroleEmployee,
        generateLinkForOnboarding
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(GenerateLink);
